const OTP_PROGRESS_BLOCK_REASON =
  "If the email address is registered with us, you will receive a one-time password.";

function normalizeReason(reason) {
  return String(reason || "")
    .trim()
    .toLowerCase();
}

export function shouldBlockOtpProgress(reason) {
  if (!reason) return false;
  return normalizeReason(reason) === normalizeReason(OTP_PROGRESS_BLOCK_REASON);
}

export { OTP_PROGRESS_BLOCK_REASON };
